import { makeStyles } from 'tss-react/mui';
import { pickIf } from '../../../../../utils/pickIf';
import { styleCondition } from '../../../../../utils/styleCondition';
import { valueCondition } from '../../../../../utils/valueCondition';

export const useStyles = makeStyles()(
  (theme, { isDistroOrder, isOrderPlaced, isReviewOrderPage } = {}) => ({
    plusButton: { marginLeft: 16 },
    addressSection: {
      width: pickIf(isDistroOrder, '100%', 'initial'),
    },
    shippingTitle: {
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(1),
      },
    },
    shippingCard: {
      width: '100% !important',
      '& > div:nth-child(1)': {
        marginBottom: valueCondition(isOrderPlaced, theme.spacing(1)),
        [theme.breakpoints.down('md')]: {
          marginBottom: valueCondition(isOrderPlaced, theme.spacing(0.5)),
        },
        [theme.breakpoints.downLandscape('md')]: {
          ...styleCondition(theme.isMobileDevice, {
            marginBottom: valueCondition(isOrderPlaced, theme.spacing(0.5)),
          }),
        },
      },
      '& > div:nth-child(2)': {
        '& > div:nth-child(1)': {
          marginBottom: valueCondition(!isOrderPlaced, theme.spacing(1.25)),
          [theme.breakpoints.down('md')]: {
            marginBottom: valueCondition(!isOrderPlaced, theme.spacing(0.75)),
          },
          [theme.breakpoints.downLandscape('md')]: {
            ...styleCondition(theme.isMobileDevice, {
              marginBottom: valueCondition(!isOrderPlaced, theme.spacing(0.75)),
            }),
          },
        },
      },
    },
    singleShippingCard: {
      marginRight: theme.spacing(2.5),
      [theme.breakpoints.down('md')]: {
        height: valueCondition(isReviewOrderPage && !isOrderPlaced, 190),
        marginRight: theme.spacing(1.5),
        paddingTop: valueCondition(
          isReviewOrderPage && !isOrderPlaced,
          theme.spacing(2),
        ),
      },
      '& > div:nth-child(1)': {
        marginBottom: valueCondition(isOrderPlaced, theme.spacing(1)),
        [theme.breakpoints.down('md')]: {
          marginBottom: valueCondition(isOrderPlaced, theme.spacing(0.5)),
        },
        [theme.breakpoints.downLandscape('md')]: {
          ...styleCondition(theme.isMobileDevice, {
            marginBottom: valueCondition(isOrderPlaced, theme.spacing(0.5)),
          }),
        },
        '& > div:nth-child(1)': {
          marginBottom: valueCondition(!isOrderPlaced, theme.spacing(1.25)),
          [theme.breakpoints.down('lg')]: {
            marginBottom: valueCondition(!isOrderPlaced, theme.spacing(1)),
          },
          [theme.breakpoints.down('md')]: {
            marginBottom: valueCondition(!isOrderPlaced, theme.spacing(0.75)),
          },
          [theme.breakpoints.downLandscape('lg')]: {
            ...styleCondition(theme.isMobileDevice, {
              marginBottom: valueCondition(!isOrderPlaced, theme.spacing(1)),
            }),
          },
          [theme.breakpoints.downLandscape('md')]: {
            ...styleCondition(theme.isMobileDevice, {
              marginBottom: valueCondition(!isOrderPlaced, theme.spacing(0.75)),
            }),
          },
        },
      },
    },
    fullAddress: {
      display: '-webkit-box',
      fontSize: 14,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      color: theme.palette.darkGrey,
      [theme.breakpoints.down('lg')]: {
        WebkitLineClamp: 3,
      },
      [theme.breakpoints.down('md')]: {
        fontSize: 12,
        WebkitLineClamp: 4,
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          WebkitLineClamp: 4,
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          fontSize: 12,
          WebkitLineClamp: 6,
        }),
      },
    },
  }),
);
